import React from 'react';
import { colors } from '../../theme';

export default function SignalBars({ sipConnected, wsConnected, privacyMode }) {
  // Calculate signal level: SIP +2, WS +1, direct connection (mode ≤ 2) +1
  let bars = 0;
  if (wsConnected) bars += 1;
  if (sipConnected) bars += 2; // SIP always connected now
  if (privacyMode <= 2) bars += 1;
  bars = Math.min(bars, 4);

  const noConnection = !wsConnected && !sipConnected;

  const labels = ['Стандартное', 'TURN Relay', 'TURNS (TLS)', 'NaCl', 'E2EE'];
  const statusLabel = noConnection ? 'Нет связи' : (labels[privacyMode] || 'Подключено');

  const barColors = (idx) => {
    if (noConnection) return colors.gray200;
    if (idx >= bars) return colors.gray200;
    // gradient: 1 bar = red, 2 = amber, 3 = yellow-green, 4 = green
    if (bars === 1) return colors.red;
    if (bars === 2) return colors.amber;
    if (bars === 3) return idx < 2 ? colors.greenDot : '#7fc4a4';
    return colors.greenDot;
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 1.5, height: 14 }}>
        {[0, 1, 2, 3].map(i => (
          <div key={i} style={{
            width: 4, borderRadius: 1,
            height: 5 + i * 3,
            background: barColors(i),
            transition: 'background 0.3s',
          }} />
        ))}
      </div>
      <span style={{ fontSize: 11, color: noConnection ? colors.red : colors.gray400, fontWeight: 500 }}>{statusLabel}</span>
    </div>
  );
}
